// keycloak.js
import Keycloak from "keycloak-js";

export function createKeycloak({ idmUrl, realm, clientId }) {
    // Initialize Keycloak
    const keycloak = new Keycloak({
        url: idmUrl, // Base URL of your Keycloak server
        realm: realm, // Your realm name
        clientId: clientId, // Client ID for your React app
    });

    return keycloak;
}

export function authenticateKeycloak(keycloak) {
    if(!keycloak.authenticated) return;
    if(keycloak.tokenParsed.aud) return;

    keycloak.init({
        onLoad: "login-required", // Redirects to Keycloak login if not authenticated
        checkLoginIframe: false,
    }).then(authenticated => {
        if (authenticated) {
            console.log("Authenticated");
            console.log("Access Token:", keycloak.token); // Access token
        } else {
            console.warn("Not authenticated");
        }
    });

    setInterval(() => {
        keycloak
            .updateToken(30) // Refresh token if it expires in 30 seconds or less
            .then(refreshed => {
                if (refreshed) {
                    console.log("Token refreshed:", keycloak.token);
                }
            })
            .catch(error => {
                console.error("Failed to refresh token:", error);
            });
    }, 60000); // Check every 60 seconds
}